export const structureTree = (data, current) => {
  if (!current) {
    current = data.find((child) => child.parent === '#');

    if (!current) {
      return;
    }
  }

  const child = {};

  child.id = current.id;
  child.name = current.text;
  child.parent = current.parent;
  child.unique = `${current.text}-${current.id}`;
  child.files = [];

  const currentChildren = data.filter((item) => item.parent === child.id);

  if (currentChildren.length > 0) {
    currentChildren.forEach((item) => child.files.push(structureTree(data, item)));
  }

  return child;
};

export const destructureTree = (data) => {
  const result = [];

  const recursive = (node, parent) => {
    result.push({ id: node.id, text: node.name, parent: parent ?? '#' });

    if (node.files.length) {
      node.files.forEach((item) => recursive(item, node.id));
    }
  };

  recursive(data);

  return result;
};
